import { RestClient, RequestResponse } from "./base/rest.client";
import { CommonDto } from "../common.dto";
import { BASE_URL } from "../config";
import * as z from "zod";

const CreateFeedbackRequestSchema = z.object({
  rating: z.number().min(1).max(5),
  comment: z.string().optional().nullable(),
});

const CreateFeedbackResponseSchema = z.object({
  id: z.number(),
  order_number: z.string(),
  rating: z.number(),
  comment: z.string().nullable().optional(),
  message: z.string(),
});

export type CreateFeedbackRequest = z.infer<typeof CreateFeedbackRequestSchema>;
export type CreateFeedbackResponse = z.infer<typeof CreateFeedbackResponseSchema>;

class FeedbackClientClass extends RestClient {
  baseUrl = BASE_URL;

  async createFeedback(
    orderNumber: string,
    data: CreateFeedbackRequest
  ): Promise<RequestResponse<CreateFeedbackResponse>> {
    const result = await this.request(
      "POST",
      `/api/front/orders/${orderNumber}/feedback`,
      {
        jsonPayload: data,
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(CreateFeedbackResponseSchema));
  }
}

export class FeedbackClient extends FeedbackClientClass {}
